<template>
	<div>
		<v-layout row wrap class="mb-5">
			<v-flex sm12 md6>
				<p class="add-event-example-sub-header-light mb-1">Last Step</p>
				<p class="add-event-step-header-big mb-2">Review and Submit</p>
				<p class="add-event-review-header">Please review your location details below.</p>

				<p class="d-inline-block add-event-review-header mb-2">Location Use Permission</p>
				<p class="add-event-step-error mb-2" v-if="!confirmLocationUse">Please review and agree to the following terms</p>
				<p class="add-event-review-content-light">
					By checking the following box, I confirm that I am allowed to use this space, and that I am the owner or leasee at this location and/or I have written consent or a permit to host events at this location.
					<v-checkbox color="link" v-model="confirmLocationUse" label="Confirm" class="mt-2"></v-checkbox>
				</p>

				<p class="add-event-step-error" v-if="!getAddLocationReadyToSubmit">
					There are one or more incomplete parts. Please review form and re-submit.
				</p>

				<v-layout row wrap class="mt-5">
					<v-flex xs12>
						<p class="d-inline-block add-event-review-header">Title</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_location_description'}">Edit</v-btn>
						<p class="d-inline-block add-event-step-error mb-2" v-if="!getAddLocationProp('title')">You must enter your location title</p>
						<p class="add-event-review-content"> {{getAddLocationProp('title')}}</p>
						
						<v-divider class="mt-2 mb-3"></v-divider>

						<p class="d-inline-block add-event-review-header">Description</p>: 
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_location_description'}">Edit</v-btn>
						<p class="add-event-step-error mb-2" v-if="!getAddLocationProp('description')">You must enter your location description</p>
						<p class="add-event-review-content" v-html="newlines(getAddLocationProp('description'))"></p>

						<v-divider class="mt-2 mb-3"></v-divider>
						
						<p class="d-inline-block add-event-review-header">Location Type:</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_location_type'}">Edit</v-btn>
						<p class="d-inline-block add-event-step-error mb-2" v-if="!getAddLocationProp('type')">You must select the type of location</p>
						<p class="add-event-review-content"> {{getAddLocationProp('type')}}</p>

						<v-divider class="mt-2 mb-3"></v-divider>

						<p class="d-inline-block add-event-review-header">Rules</p>: 
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_location_description'}">Edit</v-btn>
						<p class="add-event-review-content" v-html="newlines(getAddLocationProp('rules'))"></p>

						<v-divider class="mt-2 mb-3"></v-divider>

						<p class="d-inline-block add-event-review-header">Address:</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_location_location'}">Edit</v-btn>
						<p class="add-event-review-content"> {{getAddLocationProp('privateAddress')}} <span v-if="getAddLocationProp('apartmentCheck')"># {{getAddLocationProp('apartmentNumber')}}</span></p>
						<p class="add-event-step-error mb-2" v-if="getAddLocationProp('privateAddress') === null">You must enter the address of your location</p>
						<p 
							class="add-event-step-error mb-2" 
							v-else-if="((this.getAddLocationProp('apartmentCheck') === true) && (this.getAddLocationProp('apartmentNumber') === null))"
						>
							You must enter your apartment or room number
						</p>
						
						<v-divider class="mt-2 mb-3"></v-divider>

						<p class="d-inline-block add-event-review-header">Capacity</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_location_seating'}">Edit</v-btn>
						<p class="d-inline-block add-event-step-error mb-0" v-if="(getAddLocationProp('seats') === null) || (stepIsInvalid('/host/add/location/seating'))">You must enter a valid number of seats</p>
						<p class="add-event-review-content"> {{getAddLocationProp('seats')}}</p>

						<v-divider class="mt-2 mb-3"></v-divider>

						<p class="d-inline-block add-event-review-header">Amenities</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_location_amenities'}">Edit</v-btn>
						<choice-field-display class="pb-3" :original="locationInfoOptions" :fields="getAddLocationProp('locationInfo')" :inputs="getAddLocationProp('locationInfoInputs')"></choice-field-display>

						<v-divider class="mt-2 mb-3"></v-divider>

						<p class="d-inline-block add-event-review-header" :class="{'add-event-review-invalid': stepIsInvalid('/host/add/location/photos')}">Photos:</p>
						<v-btn style="float: right; min-width:30px!important; width:auto!important;" small flat :to="{name: 'host_add_location_photos'}">Edit</v-btn>
						<p class="add-event-step-error mb-2" v-if="getAddLocationProp('images').length < 1">You must upload at least one photo</p>
						<p class="add-event-step-error mb-2" v-if="this.getAddLocationProp('primaryImage') === null">You must select a primary photo</p>
						<div>
							<vue-dropzone
								ref="imageDropzone"
								id="dropzone"
								:options="dropzoneOptions"
							></vue-dropzone>
						</div>
					</v-flex>
				</v-layout>
			</v-flex>

			<!-- Tip Box -->
			<v-flex md4 offset-md1 class="hidden-sm-and-down">
				<v-card class="add-event-tip-box">
					<v-card-text class="p-relative pt-5">
						<div class="info-trapezoid p-absolute">
							<div class="info-content">
								<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
							</div>
						</div>
						<p class="add-event-tip-title">Double check...</p>
						<p class="add-event-tip-content">Please check to make sure everything is accurate and that you haven’t missed anything before submitting your location.</p>
						<p class="add-event-tip-content">Make sure your guests have the most up to date information possible.</p>
						<p class="add-event-tip-content">It it looks right to you, please submit.</p>
						<p class="add-event-tip-content">The earlier we get this information from you, the better.</p>
						<p class="add-event-tip-content">Thanks!</p>
					</v-card-text>
				</v-card>
			</v-flex>

			<v-dialog scrollable v-model="infoDialog">
				<v-card style="width: 100%">
					<v-card-title class="mb-0 pb-2 pt-3">
						<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
					</v-card-title>
					<v-divider class="pt-0 mt-0">
					</v-divider>
					<v-card-text style="max-height:50vh;">
						<p class="add-event-tip-title">Double check...</p>
						<p class="add-event-tip-content">Please check to make sure everything is accurate and that you haven’t missed anything before submitting your location.</p>
						<p class="add-event-tip-content">Make sure your guests have the most up to date information possible.</p>
						<p class="add-event-tip-content">It it looks right to you, please submit.</p>
						<p class="add-event-tip-content">The earlier we get this information from you, the better.</p>
						<p class="add-event-tip-content">Thanks!</p>
					</v-card-text>
					<v-divider>
					</v-divider>
					<v-card-actions>
						<v-spacer>
						</v-spacer>
						<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-layout>
	</div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.css'

import { mapGetters, mapActions } from 'vuex'
import { locationInfoOptions } from '~/store/util/values'
import { replaceNewlines } from '~/store/util/util'
import ChoiceFieldDisplay from '~/components/ChoiceFieldDisplay'
export default {
	data() {
		return {
			locationInfoOptions: locationInfoOptions,
			validSeats: false,
			selectedIndex: 0,
			mapcenter: {
				lat: 34.006933,
				lng: -118.35
			},
			mapzoom: 10,
			types: [
				{
					title: 'Home',
					value: 'house',
					description: 'The place where you sleep'
				},
				// { title: 'Apartment', value: 'apartment', description: 'A smaller place where you sleep' },
				{ title: 'Office', value: 'office', description: 'Where people work' },
				{
					title: 'Public',
					value: 'public',
					description: 'A public place such as a park'
				},
				{
					title: 'Commercial',
					value: 'commercial',
					description: 'A cafe, restaurant, or public place'
				}
			],
			place: null,
			removingImage: false,
			rules: {
				seats: value => {
					if (value < 5 || value === null) {
						this.validSeats = false
						return 'Must have at least 5 guests for a wrkprty'
					}
					this.validSeats = true
					return true
				}
			},
			dropzoneOptions: {
				paramName: 'image',
				url: '/api/v1/image-upload/',
				clickable: false,
				thumbnailWidth: 150,
				acceptedFiles: 'image/*',
				maxFilesize: 10,
				ignoreHiddenFiles: true,
				dictDefaultMessage: '<i class="fa fa-cloud-upload"></i><br>Drop or click to upload images'
			}
		}
	},
	components: {
		ChoiceFieldDisplay: ChoiceFieldDisplay,
		vueDropzone: vue2Dropzone
	},
	methods: {
		...mapActions(['setAddLocationProp', 'addLocationProcessFiles']),
		removePhoto(index) {
			this.removingImage = true
		},
		onFilePicked(event) {
			this.addLocationProcessFiles(event.target.files)
		},
		clickImage(index) {
			if (this.removingImage === false) {
				this.setAddLocationProp({
					prop: 'primaryImage',
					value: index
				})
			} else {
				let images = this.getAddLocationProp('images').slice(0)
				let urls = this.getAddLocationProp('imagesUrls').slice(0)
				let selectedIndex = this.getAddLocationProp('primaryImage')
				images.splice(index, 1)
				urls.splice(index, 1)
				this.removingImage = false

				if (index === selectedIndex) {
					selectedIndex = 0
				} else if (index < selectedIndex) {
					selectedIndex -= 1
				}

				this.setAddLocationProp({
					prop: 'images',
					value: images
				})
				this.setAddLocationProp({
					prop: 'imagesUrls',
					value: urls
				})
			}
		},
		stepIsInvalid(stepLink) {
			return !(
				this.getAddLocationProp('validSteps').includes(stepLink) ||
				this.getAddLocationProp('validSteps').includes(stepLink + '/')
			)
		},
		setPlace(place) {
			this.mapcenter = {
				lat: place.geometry.location.lat(),
				lng: place.geometry.location.lng()
			}
			this.mapzoom = 15
			let publicLocationString = ''
			for (var i = 0; i < place.address_components.length; i++) {
				if (place.address_components[i].types.includes('neighborhood')) {
					publicLocationString += place.address_components[i].long_name + ', '
				} else if (place.address_components[i].types.includes('locality')) {
					publicLocationString += place.address_components[i].long_name + ', '
				} else if (
					place.address_components[i].types.includes(
						'administrative_area_level_1'
					)
				) {
					publicLocationString += place.address_components[i].short_name + ', '
				} else if (place.address_components[i].types.includes('country')) {
					publicLocationString += place.address_components[i].short_name
				}
			}
			this.setAddLocationProp({
				prop: 'latitude',
				value: this.mapcenter.lat
			})
			this.setAddLocationProp({
				prop: 'longitude',
				value: this.mapcenter.lng
			})
			this.setAddLocationProp({
				prop: 'privateAddress',
				value: place.formatted_address
			})
			this.setAddLocationProp({
				prop: 'publicAddress',
				value: publicLocationString
			})
		},
		newlines(value) {
			return replaceNewlines(value)
		}
	},
	mounted() {
		console.log('mounted submit.vue')
		if (
			![
				this.getAddLocationProp('latitude'),
				this.getAddLocationProp('longitude')
			].includes(null)
		) {
			this.mapcenter = {
				lat: this.getAddLocationProp('latitude'),
				lng: this.getAddLocationProp('longitude')
			}
			this.place = 'nothing'
			this.mapzoom = 15
		}

		this.setAddLocationProp({ prop: 'visitedSubmit', value: true })

		// Set images
		let imageObjs = this.getAddLocationProp('imageObjs')
		console.log(imageObjs)
		let mockImage
		for (let i = 0; i < imageObjs.length; i++) {
			mockImage = { name: imageObjs[i].name, type: "image/*", size: imageObjs[i].filesize }
			console.log(mockImage)
			this.$refs.imageDropzone.manuallyAddFile(mockImage, imageObjs[i].image)
		}
	},
	computed: {
		...mapGetters([
			'getAddLocationProp',
			'getEventTags',
			'getAddLocationReadyToSubmit'
		]),
		infoDialog: {
			get() {
				return this.getAddLocationProp('infoDialog')
			},
			set(val) {
				this.setAddLocationProp({ prop: 'infoDialog', value: val })
			}
		},
		typeSelection: {
			get() {
				return this.getAddLocationProp('type')
			},
			set(val) {
				this.setAddLocationProp({
					prop: 'type',
					value: val
				})
			}
		},
		title: {
			get() {
				return this.getAddLocationProp('title')
			},
			set(val) {
				this.setAddLocationProp({
					prop: 'title',
					value: val
				})
			}
		},
		description: {
			get() {
				return this.getAddLocationProp('description')
			},
			set(val) {
				this.setAddLocationProp({
					prop: 'description',
					value: val
				})
			}
		},
		houseRules: {
			get() {
				return this.getAddLocationProp('rules')
			},
			set(val) {
				this.setAddLocationProp({
					prop: 'rules',
					value: val
				})
			}
		},
		getmapcenter() {
			return this.mapcenter
		},
		getAddress() {
			return this.getAddLocationProp('privateAddress')
		},
		markerPosition() {
			return { lat: this.mapcenter.lat, lng: this.mapcenter.lng }
		},
		seats: {
			get() {
				return this.getAddLocationProp('seats')
			},
			set(val) {
				this.setAddLocationProp({
					prop: 'seats',
					value: val
				})
			}
		},
		getAllTags: {
			get() {
				return this.getAddLocationProp('eventTagValues')
			},
			set(val) {
				this.setAddLocationProp({
					prop: 'eventTagValues',
					value: val
				})
			}
		},
		readyToSubmit() {
			return this.getAddLocationReadyToSubmit && this.confirmLocationUse
		},
		confirmLocationUse: {
			get() {
				return this.getAddLocationProp('confirmLocationUse')
			},
			set(val) {
				this.setAddLocationProp({ prop: 'confirmLocationUse', value: val })
			}
		}
	}
}
</script>
